import { createTxn, getTxPoW, userBalance } from '../../services/blockchain';
import { BASE_FEE, PENDING_BALANCE, PENDING_BALANCE_TXN } from '../config';
import { getTxPoWWithRetry } from './getTxPoWWithRetry';

export const fetchData = async (setFeeMsg, setUsrBalance) => {
  // Displays error msg after 3 seconds if balance function doesnt return a response.
  const timeout = setTimeout(function () {
    // setFeeMsg('Trying to connect to the Minima Network.');
    setFeeMsg('');
  }, 3000);
  try {
    const balanceResponse: IBalanceResponse = await userBalance();
    setUsrBalance(balanceResponse);
    clearTimeout(timeout); // Clear timeout if balance resolves before 2 seconds

    //Displays error msg if balance of Minima is 0 or less than fee.
    //TODO: Create a useeffect to update userbalance before implementing this:

    // if (Number(balanceResponse.sendable) <= 0 && Number(balanceResponse.sendable) <= fee) {
    //   setFeeMsg(
    //     'Insufficient $MINIMA Balance: Your account balance is too low to complete this request.',
    //   );
    // } else {
    //   setFeeMsg('');
    // }
  } catch (error) {
    console.error('Error fetching balance:', error);
  }
};

export const paymentProcessing = async (
  setPendingMsg,
  setPendingIsOpen,
  setUsrBalance,
  fee,
  files,
  setSentTxn,
) => {
  try {
    //Check fee amount
    //Call createTxn function with fee amount parameter

    setPendingMsg(PENDING_BALANCE_TXN);
    setPendingIsOpen(true);
    let balanceRes = await userBalance();
    if (balanceRes) {
      while (balanceRes.sendable < fee) {
        balanceRes = await userBalance();
        setUsrBalance(balanceRes);

        await new Promise((resolve) => setTimeout(resolve, 1000)); // Wait for 1 second before re-checking
      }
      const txnResponse: ITransactionResponse = await createTxn(fee, files);

      const pendinguid = txnResponse.pendinguid;

      setSentTxn({ pending: true, pendinguid, status: false });

      setPendingMsg(PENDING_BALANCE); // 'Transaction pending...'
      setPendingIsOpen(true);
    }
  } catch (err) {
    console.error(`Error in handlePayment: ${err}`);
  }
};

//Trigger function returnStatus when MDS.Pending has been updated with a receiveTxn
//Moves the status of a transaction from pending to next step.
export const returnStatus = async (
  fee,
  sentTxn,
  hasCheckedFee,
  setHasCheckedFee,
  setPendingIsOpen,
  receiveTxn,
  files,
  setPendingMsg,
  setUsrBalance,
  setSentTxn,
  setValidationMsg,
  hasCheckedNFT,
  setHasCheckedNFT,
  handleDataValidation,
) => {
  if (sentTxn.pending && !hasCheckedFee) {
    setHasCheckedFee(true); // Prevent further calls
    setPendingIsOpen(false);
    const status = await waitForPendingOrComplete(receiveTxn.pendinguid, sentTxn, receiveTxn);

    if (status === 'complete') {
      let reference: any = [];
      for (let i = 0; i < files.length; i++) {
        const localHash = files[i].fileHash;
        reference.push({ hash: localHash, index: i + 1 });
      }

      //MINT NFT removed
    }
  } else if (sentTxn.pending && !hasCheckedNFT && sentTxn.status) {
    setHasCheckedNFT(true); // Prevent further calls

    //Retreieve coinId from waitForPendingOrComplete
    const status = await waitForPendingOrComplete(receiveTxn.pendinguid, sentTxn, receiveTxn);

    if (status === 'complete') {
      await new Promise((resolve) => setTimeout(resolve, 2000));

      setPendingIsOpen(false);

      // const nftCoinId = res.response[0].coinid;
      const nftCoinId = receiveTxn.coinid;

      try {
        const txpow = await getTxPoWWithRetry(nftCoinId);
      } catch (error: any) {
        console.error(`Final Error: ${error.message}`);
        setValidationMsg('Transaction could not be found.');
      }

      const txpow = await getTxPoW(nftCoinId);

      const nftData = { coinid: nftCoinId, txpow };

      // Send coinId to handleDataValidation
      await handleDataValidation(nftData);
    } else {
      console.error(`Something went wrong with the coinid`);
    }
  } else if (status === 'pending') {
    setValidationMsg('You didnt accept pending in time.');
  }
  // }
};

// Function to handle waiting for either "pending" or "complete" status
const waitForPendingOrComplete = async (pendinguid: string, sentTxn, receiveTxn) => {
  return new Promise<string>((resolve) => {
    const checkInterval = setInterval(() => {
      // Check if status has changed to "complete"
      if (sentTxn.pendinguid === pendinguid && receiveTxn.status === true) {
        clearInterval(checkInterval);
        sentTxn.pending = false;
        receiveTxn.pending = false;
        resolve('complete'); // Status confirmed as complete
      }

      // If still pending, notify and continue checking
      if (sentTxn.pendinguid === pendinguid && receiveTxn.status === false) {
      }
    }, 1000); // Check every second
  });
};

//Updates fee when files are changed.
export const feeUpdater = (setFee, files, mintOption) => {
  if (files.length > 0) {
    if (mintOption) {
      setFee(files.length * BASE_FEE + files.length * BASE_FEE);
    }

    if (!mintOption) {
      setFee(files.length * BASE_FEE);
    }
  }
};
